import Admin from 'hive-admin';

import PageArchiveTable from 'hive-admin/src/components/PageArchiveTable';

// import tests from '../../helpers/tests';

import {
  ADMIN as FILTERS_ADMIN,
} from './filters';

import {
  ADMIN as COLUMNS_ADMIN,
} from './columns';

import {
  ADMIN as FIELDS_ADMIN,
} from './fields';

// const { viewerIsNotAdmin } = tests;

export default [
  ...Admin.compileFromLibrary(['GroupResource', {
    title: 'Imports',
    path: '/shipping/imports',
    // icon: 'car',
    // eslint-disable-next-line max-len
    singleLoadUrl: '/shippingcompaniesimports/:id/?populateCompany=true&populateCreatedBy=true',
    archiveLoadUrl: '/shippingcompaniesimports',
    archiveConfig: {
      title: 'Imports',
      label: 'Imports',
      // icon: 'car',
      createButtonSupported: false,
      // hidden: [viewerIsNotAdmin],
      // loadUrl: '/shippingcompaniesimports',
      getColumns: (props, columns) => {
        const { viewer } = props;
        if (viewer?.role === 'ADMIN') {
          return PageArchiveTable.defaultProps.getColumns(props, columns);
        }
        return PageArchiveTable.defaultProps.getColumns(
          props,
          (columns || props.columns).filter(
            column => column.path !== 'store.name'
          ),
        );
      },
    },
    singleConfig: {
      hidden: true,
      alias: '/shipping/imports',
      backButtonPaths: ['/shipping/imports'],
    },
    singleEditConfig: {
      actions: [
        ['ActionWithRequest', {
          id: 'ready',
          name: 'ready',
          title: 'Confirm',
          getRequestConfig: props => ({
            url: `/shippingcompaniesimports/${props.data._id}/ready`,
            method: 'POST',
          }),
          handleSuccess: (data, props) => props.reload(),
          skip: [props => !!props.data?.ready],
          popconfirm: true,
        }],
        ['ActionDelete', {
          skip: [props => props.data.ready === true],
        }],
      ],
    },
    redirect: [
      ['redirect.unauthorized'],
      // [
      //   'redirect.checkViewer',
      //   'role', '!==', 'ADMIN',
      //   '/store',
      // ],
    ],
    columns: COLUMNS_ADMIN,
    filters: FILTERS_ADMIN,
    fields: FIELDS_ADMIN,
  }]).pages,
];
